import { useEffect, useState } from 'react';

import { getTeamMembers } from '../services/individualBioService';
import { TeamMember } from '../types/thematicGroups';

interface UseTeamMembersProps {
  teamUuid: string;
  page?: number;
  size?: number;
}

interface UseTeamMembersReturn {
  members: TeamMember[];
  loading: boolean;
  error: string | null;
  total: number;
  currentPage: number;
  totalPages: number;
  size: number;
  setPage: (page: number) => void;
  setSize: (size: number) => void;
}

const useTeamMembers = ({
  teamUuid,
  page = 1,
  size = 50,
}: UseTeamMembersProps): UseTeamMembersReturn => {
  const [members, setMembers] = useState<TeamMember[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(page);
  const [totalPages, setTotalPages] = useState(0);
  const [currentSize, setCurrentSize] = useState(size);

  useEffect(() => {
    const fetchTeamMembers = async () => {
      if (!teamUuid) {
        return;
      }

      try {
        setLoading(true);
        setError(null);

        const data = await getTeamMembers(teamUuid, currentPage, currentSize);
        setMembers(data.items || []);
        setTotal(data.total || 0);
        setTotalPages(data.pages || 0);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Erro desconhecido');
      } finally {
        setLoading(false);
      }
    };

    fetchTeamMembers();
  }, [teamUuid, currentPage, currentSize]);

  const setPage = (page: number) => {
    setCurrentPage(page);
  };

  const setSize = (size: number) => {
    setCurrentSize(size);
    setCurrentPage(1); // Reset para primeira página quando mudar o tamanho
  };

  return {
    members,
    loading,
    error,
    total,
    currentPage,
    totalPages,
    size: currentSize,
    setPage,
    setSize,
  };
};

export default useTeamMembers;
